module.exports = __webpack_public_path__ + "88db2c3f23c33b0b5f52209293e8b62d.mp3";